import React from "react";
import { Link } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import { LoadingView } from "@solsys/solsys-reactjs";

const myCranesQuery = gql`
  query customerHomeCranes($crane_list_request: crane_list_request) {
    crane(crane_list_request: $crane_list_request) {
      edges {
        id
        name
      }
      totalCount
    }
  }
`;

// Customer landing stays on /my-cranes. The crane list at /ecrane/list is the
// technician screen and applies its own filters, which hide a customer's cranes.
export default function CustomerHome() {
  const { loading, error, data } = useQuery(myCranesQuery, {
    variables: {
      crane_list_request: {
        pagination: { limit: 100 },
        sorting: [{ field: "name", direction: "ASC" }],
      },
    },
    fetchPolicy: "network-only",
  });

  const cranes = data?.crane?.edges ?? [];

  return (
    <>
      <div className="page-header">
        <span className="page-header-title">My cranes</span>
      </div>
      <div className="add-edit" style={ { marginTop: 20 } }>
        { loading && <LoadingView /> }
        { error && <p>Your cranes could not be loaded.</p> }
        { !loading && !error && cranes.length === 0 && (
          <p>No cranes are assigned to you.</p>
        ) }
        { cranes.map((crane) => (
          <div key={ crane.id } className="edit-property">
            <Link to={ `/ecrane/edit/${crane.id}` }>{ crane.name || `Crane ${crane.id}` }</Link>
          </div>
        )) }
      </div>
    </>
  );
}
